import { Injectable, Inject } from '@angular/core';
import { Globals } from 'src/app/globals';

@Injectable()
export class ApiEndPoints {
    constructor(private globals: Globals) {
        Inject(Globals);
    }

    public apiUrls = {
        "eapps": {
            "validateEkycAadhaarToken": this.globals.BACKEND_URL_PREFIX + this.globals.CONTEXT_PATH + '/kyc/validateEkycAadhaarToken',
            "sendEkycAadhaarOTP": this.globals.BACKEND_URL_PREFIX + this.globals.CONTEXT_PATH + '/otp/sendEkycAadhaarOTP',
            "validateEkycAadhaarOTP": this.globals.BACKEND_URL_PREFIX + this.globals.CONTEXT_PATH + '/otp/validateEkycAadhaarOTP',
            "getEkycBasicInfo": this.globals.BACKEND_URL_PREFIX + this.globals.CONTEXT_PATH + '/kyc/getEkycBasicInfo',
            "validateEkycAadhaar": this.globals.BACKEND_URL_PREFIX + this.globals.CONTEXT_PATH + '/kyc/validateEkycAadhaar',
            "kycDocTypeMaster": this.globals.BACKEND_URL_PREFIX + this.globals.CONTEXT_PATH + '/kycUpload/kycDocTypeMaster',
            "saveKycDetails": this.globals.BACKEND_URL_PREFIX + this.globals.CONTEXT_PATH + '/kycUpload/saveKycDetails',
            "findKycDetailsById": this.globals.BACKEND_URL_PREFIX + this.globals.CONTEXT_PATH + '/kycUpload/findKycDetailsById',
            "saveKycDetailsFromRedirectURL": this.globals.BACKEND_URL_PREFIX + this.globals.CONTEXT_PATH + '/kycUpload/saveKycDetailsFromRedirectURL',
            "kycSearchDownload": this.globals.BACKEND_URL_PREFIX + this.globals.CONTEXT_PATH + '/ekyc/v1/searchDownloadKYCDetails',
            "generateLink": this.globals.BACKEND_URL_PREFIX + this.globals.CONTEXT_PATH + '/ekyc/v1/generateLink',
            "kycResults": this.globals.BACKEND_URL_PREFIX + this.globals.CONTEXT_PATH + '/ekyc/v1/kycResults',
            "generateKYCToken": this.globals.BACKEND_URL_PREFIX + this.globals.CONTEXT_PATH + '/ekyc/generateKYCToken',
            "getKycStatusResults": this.globals.BACKEND_URL_PREFIX + this.globals.CONTEXT_PATH + '/ekyc/v1/getKycStatusResults',
            "generateKycHypervergeToken": this.globals.BACKEND_URL_PREFIX + this.globals.CONTEXT_PATH + '/ekyc/v1/generateKycHypervergeToken',
            "loginUserDetails": this.globals.EAPPS_URL_PREFIX + this.globals.EAPPS_CONTEXT_PATH + '/loginUserDetailsWithEnc',
            "fetchMasterAppData": this.globals.BACKEND_URL_PREFIX + this.globals.CONTEXT_PATH + '/ekyc/v1/fetchMasterAppData',
            "sendKycLinkToCustomer": this.globals.BACKEND_URL_PREFIX + this.globals.CONTEXT_PATH + '/ekyc/v1/sendKycLinkToCustomer',
            "searchDownloadDefaultKYCDetails": this.globals.BACKEND_URL_PREFIX + this.globals.CONTEXT_PATH + '/ekyc/v1/searchDownloadDefaultKYCDetails',
            "ovdUpload": this.globals.BACKEND_URL_PREFIX + this.globals.CONTEXT_PATH + '/ekyc/v1/ovdUpload'
        },
    }
    public filteredEndPoints = this.apiUrls.eapps;
}
